/* eslint-disable complexity */
import {dateTimeParse} from '@gravity-ui/date-utils';
import {ComparisonOperator} from 'common/constants/survey';

import isDateRange from './isDateRange';
import isEmpty from './isEmpty';
import isValidStringDate from './isValidStringDate';

const unify = (value: unknown) => {
    return String(value).trim().toLowerCase();
};

const checkConditionForArray = (
    condition: ComparisonOperator,
    currentValue: Array<unknown>,
    expectedValue: string,
) => {
    switch (condition) {
        case ComparisonOperator.Eq:
            if (expectedValue === '') {
                return currentValue.length === 0;
            }
            return currentValue.includes(expectedValue);
        case ComparisonOperator.Neq:
            if (expectedValue === '') {
                return currentValue.length > 0;
            }
            return !currentValue.includes(expectedValue);
    }
};

const checkConditionForString = (
    condition: ComparisonOperator,
    currentValue: unknown,
    expectedValue: string,
) => {
    switch (condition) {
        case ComparisonOperator.Eq:
            if (isEmpty(currentValue) && isEmpty(expectedValue)) {
                return true;
            }
            if (unify(currentValue) === unify(expectedValue)) {
                return true;
            }
            break;
        case ComparisonOperator.Neq:
            if (isEmpty(expectedValue) && !isEmpty(currentValue)) {
                return true;
            }
            if (!isEmpty(expectedValue) && unify(currentValue) !== unify(expectedValue)) {
                return true;
            }
            break;
    }
    return false;
};

const checkConditionForDateTime = (
    condition: ComparisonOperator,
    currentValue: string,
    expectedValue: string,
) => {
    const currentDate = dateTimeParse(currentValue, {timeZone: 'utc'})?.toISOString();
    const expectedDate = dateTimeParse(expectedValue, {timeZone: 'utc'})?.toISOString();
    return checkConditionForString(condition, currentDate, String(expectedDate));
};

const checkCondition = (
    condition: ComparisonOperator,
    currentValue: unknown,
    expectedValue: string,
) => {
    if (Array.isArray(currentValue)) {
        return checkConditionForArray(condition, currentValue.map(unify), unify(expectedValue));
    }
    if (isValidStringDate(expectedValue)) {
        if (isValidStringDate(currentValue)) {
            return checkConditionForDateTime(condition, currentValue, expectedValue);
        }
        if (currentValue && typeof currentValue === 'object' && isDateRange(currentValue)) {
            const beginMatch = checkConditionForDateTime(
                condition,
                currentValue.begin,
                expectedValue,
            );
            const endMatch = checkConditionForDateTime(condition, currentValue.end, expectedValue);
            return beginMatch || endMatch;
        }
    }

    if (typeof currentValue === 'boolean' && ['True', 'False'].includes(expectedValue)) {
        return checkConditionForString(condition, currentValue ? 'True' : 'False', expectedValue);
    }

    return checkConditionForString(condition, currentValue, expectedValue);
};
export default checkCondition;
